import { FC, useEffect, useState } from 'react';
import { ChevronDarkRightIcon } from 'Components';
import { useCardType } from 'Hooks';
import { Box, Typography } from '@material-ui/core';
import { OnOnlineApplicationCardQueryItemModel } from 'Models';
import { fontSizes, gutters } from 'Theme/Variables';
import { useHistory } from 'react-router-dom';
import './CardApplicationItem.scss';
import { routePath } from 'Navigator/routes';
import RedCard from 'Assets/Images/cardTypes/red.png';
import StandardCardComparisonDialog from './StandardCardComparisonDialog';

type CardApplicationItemProps = {
  item: OnOnlineApplicationCardQueryItemModel;
  checkAlreadyApplicationStatus: (event: OnOnlineApplicationCardQueryItemModel) => void;
  selectedType?: string | null;
  onBlockedCardClick?: () => void;
  onStandardCardClick?: (item: OnOnlineApplicationCardQueryItemModel) => void;
  onContinuePlusFromStandard?: () => void;
  onContinueStandardCard?: () => void;
  isOpenStandardComparisonDialog?: boolean;
  onCloseStandardDialog?: () => void;
};

const CardApplicationItem: FC<CardApplicationItemProps> = ({
  item,
  checkAlreadyApplicationStatus,
  selectedType,
  onBlockedCardClick,
  onStandardCardClick,
  onContinuePlusFromStandard,
  onContinueStandardCard,
  isOpenStandardComparisonDialog,
  onCloseStandardDialog,
}) => {
  const { cardPath } = useCardType(item.ProductCode);
  const history = useHistory();
  const [imgSrc, setImgSrc] = useState<string>(cardPath || RedCard);
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  // cardPath değiştiğinde imgSrc'yi güncelle
  useEffect(() => {
    if (cardPath) {
      setImgSrc(cardPath);
      setImageLoaded(false);
    }
  }, [cardPath]);

  // Resmi önceden yükle
  useEffect(() => {
    if (cardPath) {
      const img = new Image();
      img.onload = () => setImageLoaded(true);
      img.onerror = () => setImgSrc(RedCard);
      img.src = cardPath;
    }
  }, [cardPath]);

  const handleCardClick = () => {
    if (item.ProductCode === 'IKT_STD') {
      onStandardCardClick?.(item);
      return;
    }

    if (item.ProductCode === 'IKT_ORC' || item.ProductCode === 'IKT_SPR') {
      history.push(routePath.studentCard, { item, selectedType });
    } else {
      checkAlreadyApplicationStatus(item);
    }
  };
  return (
    <div>
      <div
        key={item.ProductName}
        onClick={handleCardClick}
        tabIndex={0}
        onKeyDown={(e)=>{
          if(e.key === 'Enter' || e.key === ' '){
            e.preventDefault();
            handleCardClick();
          }
        }

        }
        role="button"
        className="cardApplicationItem__item"
        itemID="applyCardBtnTest"
      >
        <div className="cardApplicationItem__item__first-row">
          <img 
            className="cardApplicationItem__item__img" 
            src={imgSrc} 
            alt={item.ProductName}
            loading="eager"
            decoding="sync"
            onError={() => setImgSrc(RedCard)}
          />
          <Typography variant="h3" component="span" align="center">
            <Box
              style={{ textTransform: 'capitalize' }}
              ml={gutters.regular}
              fontSize={fontSizes.regular}
              fontWeight={600}
            >
              {item.ProductName.toLocaleLowerCase('tr-TR')}
            </Box>
          </Typography>
        </div>
        <ChevronDarkRightIcon />
      </div>
      
      <StandardCardComparisonDialog
        open={isOpenStandardComparisonDialog || false}
        onClose={onCloseStandardDialog || (() => {})}
        onCancel={onCloseStandardDialog || (() => {})}
        onContinuePlus={onContinuePlusFromStandard || (() => {})}
        onContinueStandard={onContinueStandardCard || (() => {})}
      />
    </div>
  );
};
export default CardApplicationItem;
